namespace Solovis.Site.HelpManager {

    export var _solovisAcademyUrl = "~/JumpTo/GoToSolovisAcademy";
    export var _askSolovisUrl = "~/JumpTo/GoToAskSolovis";
    export var _pageHelpLinksProviders = null;

    // Safety limit on the percent-encoded pa_options value; above it the options are dropped.
    export const _askSolovisMaxEncodedOptionsLength = 6 * 1024;

    /**
     * Builds the "Ask Solovis" URL carrying the context of the current page: pa_host always, and on a
     * report page with a report code also pa_report and (when the hash has options and they fit) pa_options.
     */
    export function buildAskSolovisUrl(pageViewModel: any, host: string, hash: string): string {
        const params: string[] = [];
        const addParam = (name: string, value: string) => params.push(name + "=" + encodeURIComponent(value));

        addParam("pa_host", host);

        if (pageViewModel && pageViewModel.isReportView && pageViewModel.reportCode) {
            addParam("pa_report", pageViewModel.reportCode);

            // Already percent-encoded once, so pushed as is rather than through addParam.
            const encodedOptions = HelpManager._getEncodedOptionsFromHash(hash);
            if (encodedOptions && encodedOptions.length > HelpManager._askSolovisMaxEncodedOptionsLength) {
                console.warn("Ask Solovis: report options dropped; " + encodedOptions.length
                    + " encoded characters exceeds the " + HelpManager._askSolovisMaxEncodedOptionsLength + " limit.");
            }
            else if (encodedOptions) {
                params.push("pa_options=" + encodedOptions);
            }
        }

        return HelpManager._askSolovisUrl + "?" + params.join("&");
    }

    // Returns the base64 "options" value of the hash, percent-encoded once; null if absent.
    // Parsed with ControlRoute, as the report page itself reads the hash (ControlHost.processHashUrlChange).
    export function _getEncodedOptionsFromHash(hash: string): string | null {
        const route = new Solovis.UI.ControlRoute({ route: (hash || "").replace(/^#/, "") });
        let optionsBase64: string = route.routeData.options;
        if (!optionsBase64) {
            return null;
        }

        try {
            optionsBase64 = decodeURIComponent(optionsBase64);
        }
        catch {
            // Not valid percent-encoding; use the value as it appears.
        }

        return encodeURIComponent(optionsBase64);
    }

    export function openAskSolovis(): void {
        const url = HelpManager.buildAskSolovisUrl((window as any).PageViewModel, window.location.host, window.location.hash);
        // noopener: Foresight closes any tab that still has window.opener when it lands signed in.
        window.open(Solovis.resolveUrl(url), "_blank", "noopener");
    }

    export function showHelpMenu(linkElement) {
        $(linkElement).addClass("active");

        var links = [];

        if (HelpManager._pageHelpLinksProviders) {
            for (var providerName in HelpManager._pageHelpLinksProviders) {
                try {
                    var linkProvider = HelpManager._pageHelpLinksProviders[providerName];
                    var pageLinks = linkProvider();
                    if (pageLinks && pageLinks.length > 0) {
                        links = links.concat(pageLinks);
                        links.push({ separator: true });
                    }
                }
                catch (ex) {
                    links.push({ html: "Error when calling page help links provider." });
                }
            }
        }

        links.push({
            label: "Help Index",
            href: "~/Help/HelpIndex",
            click: function () { HelpManager.showHelpIndex(); }
        });

        links.push({
            label: "Solovis Academy",
            href: HelpManager._solovisAcademyUrl
        });

        var portalServices = new Solovis.Portal.SitePortalServices();
        if(portalServices.cachedModuleOptions().isEnabled("NewInvestmentRequest")) {
          links.push({ separator: true });

          links.push({
              label: "New Investment Request",
              click: function () { new Solovis.Site.RequestNewInvestment.RequestNewInvestmentDialog(); }
          });
        }

        if ((Solovis as any).Info.userEligibleForAskSolovisLink) {
            links.push({ separator: true });

            links.push({
                label: "Ask Solovis",
                click: function () { HelpManager.openAskSolovis(); },
                dataTestId: "ask-solovis"
            });
        }

        var linkPanel = Solovis.UI.PopupLinkPanel.showLinks({
            offsetElement: linkElement,
            offsetRight: true,
            offsetBottom: true,
            fromRightEdge: true,
            links: links,

            close: function () {
                $(linkElement).removeClass("active");
            }
        });
    }

    export function showHelpIndex(): void {
        HelpManager.showHelpLinkInDialog("~/Help/HelpIndex");
    };


    export function showHelpLinkInDialog(
        url: string,
        opts?: { onClose?: () => void; }
    ): void {
        const self = this;

        if (Solovis.isExternalUrl(url)) {
            window.open(Solovis.resolveUrl(url), "_blank");
        } else {
            if (!this._helpDialog) {
                var helpIframe = $("<iframe>").attr("src", Solovis.resolveUrl(url))
                    .css("width", "100%").css("height", "100%").css("border", "0").css("box-sizing", "border-box");

                var dialogOptions: any = {
                    container: helpIframe,

                    title: "Help",
                    autoOpen: true,
                    center: true,
                    destroyOnClose: true,
                    pinned: ["True"],
                    actions: ["Close"],

                    close: function () {
                        self._helpDialog = null;
                        opts?.onClose?.();
                    }
                };

                dialogOptions.width = $(window).width() - 100;
                dialogOptions.height = $(window).height() - 200;

                this._helpDialog = new Solovis.UI.Dialog(dialogOptions);
            }
            else {
                this._helpDialog.options.container.attr("src", Solovis.resolveUrl(url));
            }
        }
    }


    /**
     * linkProvider should be a function that returns an array of links compatible with the PopupLinkPanel.
     * It is recommended that help clicks provide click event to call HelpManager.showHelpLinkInDialog.
     * @param providerName
     * @param linkProvider
     */
    export function setPageHelpLinksProvider(providerName, linkProvider) {      
        if (!HelpManager._pageHelpLinksProviders) {
            HelpManager._pageHelpLinksProviders = {};
        }

        HelpManager._pageHelpLinksProviders[providerName] = linkProvider;
    }



    export interface HelpDefinitionData {
        text?: string;
        html?: string | JQuery | HTMLElement;
        url?: string;
        useDescriptionProperty?: boolean;
    }

    export function showCustomHelpDialog(
        helpDefinition: string | HelpDefinitionData,
        helpContext?: {
            title?: string,
            resourceId?: number,
            portalServices?: Solovis.Portal.IPortalServices,
            onClose?: () => void;
        }
    ): void {
        let helpDefinitionData: HelpDefinitionData;
        if (typeof helpDefinition === "string") {
            helpDefinitionData = {
                text: helpDefinition
            };
        }
        else {
            helpDefinitionData = helpDefinition;
        }

        if (helpDefinitionData.url) {
            let urlToUse = helpDefinitionData.url;
            if (helpContext && helpContext.portalServices) {
                urlToUse = Solovis.resolveUrl(urlToUse, helpContext.portalServices.siteUrl());
            }

            HelpManager.showHelpLinkInDialog(urlToUse, {
                onClose: helpContext?.onClose,
            });
            return;
        }

        var title = "Help";
        if (helpContext && helpContext.title) {
            title = helpContext.title;
        }

        if (helpDefinitionData.useDescriptionProperty) {
            // Use description property for help, so we need resourceId from helpContext.
            if (!helpContext.resourceId) {
                Solovis.UI.alert("ResourceId not set.", title);
            }
            else {
                var resourceId = helpContext.resourceId;
                var propDefIdForDescription = 7;
                (Solovis as any).Reports.ReportDataLoader.loadDataSetAsync(
                    "/Solovis/Metadata/ResourcePropertyValues",
                    { resourceId: resourceId, propertyDefinitionIdList: [propDefIdForDescription] },
                    function (response, success) {
                        if (success) {
                            var messageHtml = "NOTE: Add Description property to report for help to show up here.";
                            if (response.result.dataSet) {
                                var dataSet = response.result.dataSet;
                                if (dataSet.propertyValues && dataSet.propertyValues.length > 0) {
                                    var propValue = dataSet.propertyValues[0];
                                    if (propValue.value && propValue.value.s && propValue.value.s.length > 0) {
                                        messageHtml = propValue.value.s[0];
                                    }
                                }
                            }

                            Solovis.UI.alert(messageHtml, title);
                        }
                    },
                    {
                        invokeMethod: "invokeAndWait"
                    });
            }
        }
        else {
            var html = $("<div>");
            if (typeof helpDefinitionData.text === "string") {
                html.text(helpDefinitionData.text);
            }
            else if (helpDefinitionData.html) {
                (html as any).html(helpDefinitionData.html);
            }

            Solovis.UI.alert(html, title);
        }
    }
}


